import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import Collection from "@/pages/Collection";
import FragranceDetail from "@/pages/FragranceDetail";
import Decants from "@/pages/Decants";
import PerfumeWax from "@/pages/PerfumeWax";
import Story from "@/pages/Story";
import Journal, { JournalPost } from "@/pages/Journal";
import CustomerCare from "@/pages/CustomerCare";
import PolicyPage from "@/pages/PolicyPage";
import FAQPage from "@/pages/FAQPage";
import ContactPage from "@/pages/ContactPage";
import ScentFinder from "@/pages/ScentFinder";
import CartPage from "@/pages/CartPage";
import AdminPage from "@/pages/admin/AdminPage";
import { WhatsAppBubble } from "@/components/WhatsAppBubble";
import { CartProvider } from "@/lib/cart";

const Site = ({ children }) => (
  <>
    <Navbar />
    <main className="min-h-screen">{children}</main>
    <Footer />
    <WhatsAppBubble />
  </>
);

const AppRoutes = () => {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return <AdminPage />;
  return (
    <Site>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/collection" element={<Collection />} />
        <Route path="/scent-finder" element={<ScentFinder />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/fragrance/:slug" element={<FragranceDetail />} />
        <Route path="/decants" element={<Decants />} />
        <Route path="/solid-perfume" element={<PerfumeWax />} />
        <Route path="/perfume-wax" element={<PerfumeWax />} />
        <Route path="/story" element={<Story />} />
        <Route path="/journal" element={<Journal />} />
        <Route path="/journal/:slug" element={<JournalPost />} />
        <Route path="/customer-care" element={<CustomerCare />} />
        <Route path="/customer-care/shipping-delivery" element={<PolicyPage policyKey="shipping-delivery" />} />
        <Route path="/customer-care/returns-exchanges" element={<PolicyPage policyKey="returns-exchanges" />} />
        <Route path="/customer-care/privacy" element={<PolicyPage policyKey="privacy" />} />
        <Route path="/customer-care/terms" element={<PolicyPage policyKey="terms" />} />
        <Route path="/customer-care/complaints" element={<PolicyPage policyKey="complaints" />} />
        <Route path="/customer-care/faq" element={<FAQPage />} />
        <Route path="/customer-care/contact" element={<ContactPage />} />
        <Route path="/contact" element={<ContactPage />} />
      </Routes>
    </Site>
  );
};

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.08, duration: 1.4 }}>
      <CartProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster theme="light" position="bottom-right" toastOptions={{ style: { background: "#DDD3C1", border: "1px solid rgba(143,107,58,0.45)", color: "#2B2118" } }} />
        </BrowserRouter>
      </CartProvider>
    </ReactLenis>
  );
}

export default App;
